import { render, staticRenderFns } from "./create.vue?vue&type=template&id=115a2006&scoped=true"
import script from "./create.vue?vue&type=script&lang=ts"
export * from "./create.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a2006",
  null
  
)

export default component.exports